<div class="container-fluid mt-2">
  <p-panel styleClass="p-shadow-3">
    <ng-template pTemplate="header">
      <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
        <span><b>Cadastrar Tipo O.S</b></span>
        <div class="grid ml-2" style="display: flex; gap: 10px;">
          <button pButton label="Importação" icon="pi pi-file" (click)="showDialog()"
            class="p-button-sm p-button-mobile p-button-import" style="width: auto;"></button>
          <button class="btn btn-outline-secondary" (click)="exportarExcel()" style="width: auto;">
            <em class="fa fa-download fa-xs"></em> Export Excel
          </button>
        </div>
      </div>
    </ng-template>
    <div class="custom-box p-shadow-3 flex justify-content-center flex-wrap" style="margin: 0px 0px 20px 0px;">
      <div class="col-12 grid flex align-items-center"
        style="height: 41px;display: flex;justify-content: space-between;">
        <div class="flex align-items-center" style="display: flex;">
          <button pButton label="Novo" icon="pi pi-plus"
            class="p-button-sm mb-3 mr-2 mt-3 p-button-success p-button-mobile-filter" (click)="insertDados(dados)">
          </button>
          <button pButton label="" pTooltip="Atualizar Tabela" icon="pi pi-trash" [disabled]="selectedDados.length == 0"
            class="p-button-sm mb-3 mr-2 mt-3 p-0 p-button-mobile-label-empty p-button-square p-button-danger"
            (click)="deleteMultiplo()">
          </button>
          <button pButton label="" pTooltip="Atualizar Tabela" icon="pi pi-refresh" (click)="recarregaDados()"
            class="p-button-sm mb-3 mt-3 p-0 p-button-mobile-label-empty p-button-square">
          </button>
        </div>
        <div class="flex align-items-center" style="display: flex;">
          <p-dropdown [showClear]="true" field="descricao" id="descricao" [options]="descricaoTipoOs"
            [(ngModel)]="filtros.descricao" placeholder="{{'Descrição'}}" [filter]="true" appendTo="body"
            [virtualScroll]="true" itemSize="30" class="dropFiltros">
          </p-dropdown>
          <p-dropdown showClear="true" field="tipo" id="tipo" [options]="tipoOsSelecionar" [(ngModel)]="filtros.tipo"
            placeholder="{{'Tipos'}}" [filter]="true" [virtualScroll]="true" appendTo="body" itemSize="30"
            class="dropFiltros ml-2"></p-dropdown>
          <button pButton label="Filtrar" icon="pi pi-filter" (click)="filtrosAPI()"
            class="p-button-sm mb-3 mt-3 ml-2 p-button-secondary p-button-mobile-filter">
          </button>
        </div>
      </div>
    </div>
    <p-toast key="myKey1" position="top-right"></p-toast>
    <p-table #dt [columns]="selectedColumns" [columns]="cols" [value]="dados" [rowHover]="true" [rows]="10"
      [showCurrentPageReport]="true" [loading]="loading"
      styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
      [autoLayout]="true" selectionMode="multiple" [globalFilterFields]="['descricao','tipo']"
      [(selection)]="selectedDados" id="excel-table">
      <ng-template #message pTemplate="emptymessage" let-columns>
        <tr *ngIf="dados?.length != 0">
          <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3"
            style="padding: 20px;">
            <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            style="width: 3rem;background: black;background-color: #212529;color: white;border-color: rgb(105, 105, 105);">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field"
            style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
            [ngStyle]="{'width': col.width}">
            {{col.header}}
            <p-sortIcon [field]="col.field" class="p-sortable-colum"
              *ngIf="col.field !== 'selecionar' && col.field !== 'edit'">
            </p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dados let-columns="columns">
        <tr>
          <td>
            <p-tableCheckbox [value]="dados"></p-tableCheckbox>
          </td>
          <td *ngFor="let col of columns">
            <div *ngIf="col.field != 'status'">
              {{ col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
            </div>
            <p-badge *ngIf="col.field == 'status' && dados[col.field] == 0 && dados.qtdeErros == 0"
              value="Importando..." severity="warning" size="large" styleClass="d-block">
            </p-badge>
            <p-badge *ngIf="col.field == 'status' && dados[col.field] == 1 && dados.qtdeErros == 0"
              value="Pronto p/ Processar" severity="info" size="large" styleClass="d-block">
            </p-badge>
            <p-badge *ngIf="col.field == 'status' && dados.qtdeErros > 0" value="Corrigir erros" severity="danger"
              size="large" styleClass="d-block">
            </p-badge>
            <span *ngIf="col.field == 'status' && dados[col.field] == 2 && dados.qtdeErros == 0"
              class="p-badge p-badge-lg p-badge-primary d-block">
              Processando
              <i class="ml-1 pi pi-spin pi-spinner"></i>
            </span>
            <p-badge *ngIf="col.field == 'status' && dados[col.field] == 3 && dados.qtdeErros == 0" value="Pronto"
              size="large" severity="success" styleClass="d-block">
            </p-badge>
            <div style="display: flex;">
              <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-info p-btn-sm p-mr-1"
                (click)="editDados(dados)" pTooltip="Editar" *ngIf="col.field === 'edit'">
              </button>
              <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-btn-sm p-mr-1"
                (click)="deleteUnique(dados)" pTooltip="Excluir" *ngIf="col.field === 'edit'">
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-paginator *ngIf="totalRegistros > 10" [rows]="tamanhoPagina" [(first)]="first" [totalRecords]="totalRegistros"
      [rowsPerPageOptions]="[10,20,30,50,100]" (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} registro(s)">
    </p-paginator>
    <div class="card" *ngIf="dados?.length === 0">
      <div class="card-body bg-no-records p-shadow-3">
        <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
      </div>
    </div>
  </p-panel>
</div>
<p-dialog class="p-dialog-import" header="Importação de Arquivos" [(visible)]="displayImport" [style]="{width: '785px'}"
  [modal]="true">

  <div class="d-flex justify-content-center">
    <p-progressSpinner *ngIf="progress"></p-progressSpinner>
  </div>

  <p-fileUpload *ngIf="!progress" #fileUploader mode="advanced" fileLimit="1" name="myfile[]" customUpload="true"
    accept=".xls,.xlsx" (uploadHandler)="onUpload($event,fileUploader)" (onSelect)="onSelectFile($event,fileUploader)"
    (onProgress)="progressReport($event)" (onRemove)="onRemoveFile($event)" (onClear)="onRemoveFile()"
    chooseLabel="Arquivo" uploadLabel="Enviar" cancelLabel="Cancelar">
    <ng-template let-file pTemplate='file'>
      <div class="container">
        <div class="row">
          <div class="col col-sm d-flex align-items-center ml-3">
            <div>{{file.name}} - {{file.size | filesize}}</div>
          </div>
          <div class="col col-sm align-items-center">
            <div>
              <button class="float-right mr-3" icon="pi pi-times" pButton type="button"
                (click)="removeFile(file, fileUploader)">
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-fileUpload>
  <p-progressBar *ngIf="!progress" [value]="progressBarPerc"></p-progressBar>
  <div class="jumbotron mt-1">
    <p class="h5">Informações:</p>
    <ul>
      <li>
        <legend class="text-muted h6">Só é permitido arquivo do tipo XLS ou XLSX.</legend>
      </li>
      <li>
        <legend class="text-muted h6">Arquivo Modelo:</legend>
        <p-button icon="pi pi-file-excel" class="mt-2" label="Modelo" 
        (click)="downloadModelo()"></p-button>

      </li>
    </ul>
  </div>
</p-dialog>

<p-confirmDialog key="tipoItem" [style]="{width: '450px'}"></p-confirmDialog>
<p-toast key="tipoItem" position="bottom-right"></p-toast>
<p-dialog [(visible)]="dadosDialog" [style]="{width: '480px'}" header="Editar" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <p-toast key="error" position="bottom-right"></p-toast>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label for="descricao">Descrição</label>
        <input pInputText styleClass="p-inputtext-sm" [(ngModel)]="dado.descricao" inputId="descricao"
          placeholder="Descrição tipo de os" appendTo="body">
      </div>
      <div class="p-field p-col-12">
        <label for="marca">Marca</label>
        <p-dropdown [showClear]="true" field="tipo" id="tipo" [options]="tiposMarca" [(ngModel)]="selectMarca"
          placeholder="{{'Marca'}}" [filter]="true" [virtualScroll]="true" appendTo="body" itemSize="30" maxlength="149"
          required>
        </p-dropdown>
        <small class="p-invalid text-danger" *ngIf="submitted && !selectMarca">Marca é
          Obrigatório!</small>
      </div>
      <div class="p-field p-col-12">
        <label for="tipo">Tipo O.S</label>
        <input pInputText styleClass="p-inputtext-sm" [(ngModel)]="dado.tipo" inputId="tipo"
          placeholder="Descreva um tipo" appendTo="body" maxlength="9" required>
        <small class="p-invalid text-danger" *ngIf="submitted && !dado.tipo">Tipo é
          Obrigatório!</small>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button pButton pRipple label="Salvar" icon="pi pi-check" class="p-button-text" (click)="saveDados()"
      [disabled]="!selectMarca || !dado.tipo"></button>
  </ng-template>
</p-dialog>

<p-confirmDialog key="tipo" [style]="{width: '450px'}"></p-confirmDialog>
<p-toast key="tipo" position="bottom-right"></p-toast>